import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BackendListModel } from 'src/app/models/common/list.model';
import { ApiRoutes } from 'src/app/services/apiroutes';

@Injectable({
  providedIn: 'root'
})
export class ContainerOffHireService {
  base_url = ApiRoutes.ContainerMaster;

  constructor(private http: HttpClient) { }
  postValidateContainer(data): Observable<any> {
    let url = `${this.base_url}mark_containers_off_hired/?only_validate=true`;
    return this.http.post(url, data);
  }

  getAllContainerList(page_size = 10, page = 1, search = '', order = ''): Observable<BackendListModel<any>> {
    let url = `${this.base_url}mark_containers_off_hired/`;
    let urlObj = new URL(url);
    urlObj.searchParams.append('page_size', String(page_size));
    urlObj.searchParams.append('page', String(page));
    urlObj.searchParams.append('search', String(search));
    urlObj.searchParams.append('o', String(order));

    return this.http.get<BackendListModel<any>>(String(urlObj));
  }

  postOffHireContainer(data): Observable<any> {
    let url = `${this.base_url}mark_containers_off_hired/`;
    return this.http.post(url, data);
  }
}
